import { PageLocatorMap } from '../types/PageLocatorMap';

export const activationPage = {
  alert: {
    deliverPinError: 'activation.alert.deliver-pin-error',
    parameterError: 'activation.alert.parameter-error',
    signInLink: 'activation.alert.signin-link',
    signUpLink: 'activation.alert.signup-link',
  },
  footer: {
    root: 'activation.footer',
  },
  form: {
    h1: 'activation.form.heading1',
    h2: 'activation.form.heading2',
    phoneInput: 'activation.form.phone-input',
    phoneInputError: 'activation.form.phone-error',
    privacyLink: 'activation.form.privacy-link',
    root: 'activation.form.root',
    submitButton: 'activation.form.submit-button',
    termsCheckbox: 'activation.form.terms-checkbox',
    termsCheckboxError: 'activation.form.terms-error',
    termsLink: 'activation.form.terms-link',
  },
  header: {
    root: 'activation.header',
  },
} as const satisfies PageLocatorMap;
